'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveRows = exports.moveLabels = exports.moveChildrenLabels = undefined;

var _findIndex = require('lodash/findIndex');

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function moveChildrenLabels(columns, _ref) {
  var sourceLabel = _ref.sourceLabel;
  var targetLabel = _ref.targetLabel;

  var sourceIndex = (0, _findIndex2.default)(columns, function (column) {
    return (0, _findIndex2.default)(column.children, { header: { label: sourceLabel } }) >= 0;
  });

  if (sourceIndex < 0) {
    return null;
  }

  var targetIndex = (0, _findIndex2.default)(columns, function (column) {
    return (0, _findIndex2.default)(column.children, { header: { label: targetLabel } }) >= 0;
  });

  if (targetIndex < 0) {
    return null;
  }

  // Allow drag and drop only within the same column
  if (sourceIndex !== targetIndex) {
    return null;
  }

  var movedChildren = moveLabels(columns[sourceIndex].children, {
    sourceLabel: sourceLabel, targetLabel: targetLabel
  });

  if (!movedChildren) {
    return null;
  }

  return {
    target: sourceIndex,
    columns: movedChildren.columns
  };
}

function moveLabels(columns, _ref2) {
  var sourceLabel = _ref2.sourceLabel;
  var targetLabel = _ref2.targetLabel;

  var sourceIndex = (0, _findIndex2.default)(columns, { header: { label: sourceLabel } });

  if (sourceIndex < 0) {
    return null;
  }

  var targetIndex = (0, _findIndex2.default)(columns, { header: { label: targetLabel } });

  if (targetIndex < 0) {
    return null;
  }

  var movedColumns = move(columns, sourceIndex, targetIndex);

  return {
    source: movedColumns[sourceIndex],
    target: movedColumns[targetIndex],
    columns: movedColumns
  };
}

function move(data, sourceIndex, targetIndex) {
  // Idea
  // a, b, c, d, e -> move(b, d) -> a, c, d, b, e
  // a, b, c, d, e -> move(d, a) -> d, a, b, c, e
  // a, b, c, d, e -> move(a, d) -> b, c, d, a, e
  var sourceItem = data[sourceIndex];

  // 1. detach - a, c, d, e - a, b, c, e, - b, c, d, e
  var ret = data.slice(0, sourceIndex).concat(data.slice(sourceIndex + 1));

  // 2. attach - a, c, d, b, e - d, a, b, c, e - b, c, d, a, e
  return ret.slice(0, targetIndex).concat([sourceItem]).concat(ret.slice(targetIndex));
}

function moveRows(rows, _ref3) {
  var sourceRowId = _ref3.sourceRowId;
  var targetRowId = _ref3.targetRowId;

  var sourceIndex = (0, _findIndex2.default)(rows, { id: sourceRowId });

  if (sourceIndex < 0) {
    return null;
  }

  var targetIndex = (0, _findIndex2.default)(rows, { id: targetRowId });

  if (targetIndex < 0) {
    return null;
  }

  return move(rows, sourceIndex, targetIndex);
}

exports.moveChildrenLabels = moveChildrenLabels;
exports.moveLabels = moveLabels;
exports.moveRows = moveRows;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-dnd/dist/move.js
// module id = 1382
// module chunks = 0